const MESSAGES: Readonly<{ [key: string]: string }> = {
  LOGOUT: 'logout'
}

export default MESSAGES
